"use strict";
export const appointmentBookRequest = validate10;
const schema11 = { "$id": "#/definitions/appointmentBookRequest", "type": "object", "additionalProperties": false, "properties": { "insuranceType": { "type": "string", "enum": ["legally", "privately"] }, "typeId": { "type": "number" }, "location": { "type": "string", "enum": ["onSite", "remote"] }, "salutation": { "type": "string", "enum": ["Herr", "Frau", "Divers"] }, "firstName": { "type": "string", "minLength": 1 }, "lastName": { "type": "string", "minLength": 1 }, "email": { "type": "string", "format": "idn-email" }, "phoneCountry": { "type": "string", "minLength": 1 }, "phone": { "type": "string", "minLength": 1, "pattern": "^[0-9]+$" }, "street": { "type": "string", "minLength": 1 }, "postalCode": { "type": "string", "minLength": 1 }, "city": { "type": "string", "minLength": 1 }, "privacyConsent": { "const": true } }, "required": ["insuranceType", "typeId", "location", "salutation", "firstName", "lastName", "email", "phoneCountry", "phone", "street", "postalCode", "city", "privacyConsent"] };
const func2 = Object.prototype.hasOwnProperty;
import __req_func3 from "ajv/dist/runtime/ucs2length.js";
const func3 = __req_func3.default;
import __req_formats0 from "../formats.js";
const formats0 = __req_formats0["idn-email"];
const pattern0 = new RegExp("^[0-9]+$", "u");
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/appointmentBookRequest" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.insuranceType === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "insuranceType" }, message: "must have required property '" + "insuranceType" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.typeId === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "typeId" }, message: "must have required property '" + "typeId" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.location === undefined) {
            const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "location" }, message: "must have required property '" + "location" + "'" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.salutation === undefined) {
            const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "salutation" }, message: "must have required property '" + "salutation" + "'" };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (data.firstName === undefined) {
            const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "firstName" }, message: "must have required property '" + "firstName" + "'" };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
        if (data.lastName === undefined) {
            const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "lastName" }, message: "must have required property '" + "lastName" + "'" };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (data.email === undefined) {
            const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property '" + "email" + "'" };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
        if (data.phoneCountry === undefined) {
            const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "phoneCountry" }, message: "must have required property '" + "phoneCountry" + "'" };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
        }
        if (data.phone === undefined) {
            const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "phone" }, message: "must have required property '" + "phone" + "'" };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
        if (data.street === undefined) {
            const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "street" }, message: "must have required property '" + "street" + "'" };
            if (vErrors === null) {
                vErrors = [err9];
            }
            else {
                vErrors.push(err9);
            }
            errors++;
        }
        if (data.postalCode === undefined) {
            const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "postalCode" }, message: "must have required property '" + "postalCode" + "'" };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
        if (data.city === undefined) {
            const err11 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "city" }, message: "must have required property '" + "city" + "'" };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
        if (data.privacyConsent === undefined) {
            const err12 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "privacyConsent" }, message: "must have required property '" + "privacyConsent" + "'" };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(func2.call(schema11.properties, key0))) {
                const err13 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
        if (data.insuranceType !== undefined) {
            let data0 = data.insuranceType;
            if (typeof data0 !== "string") {
                const err14 = { instancePath: instancePath + "/insuranceType", schemaPath: "#/properties/insuranceType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            if (!((data0 === "legally") || (data0 === "privately"))) {
                const err15 = { instancePath: instancePath + "/insuranceType", schemaPath: "#/properties/insuranceType/enum", keyword: "enum", params: { allowedValues: schema11.properties.insuranceType.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.typeId !== undefined) {
            let data1 = data.typeId;
            if (!((typeof data1 == "number") && (isFinite(data1)))) {
                const err16 = { instancePath: instancePath + "/typeId", schemaPath: "#/properties/typeId/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.location !== undefined) {
            let data2 = data.location;
            if (typeof data2 !== "string") {
                const err17 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
            if (!((data2 === "onSite") || (data2 === "remote"))) {
                const err18 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/enum", keyword: "enum", params: { allowedValues: schema11.properties.location.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.salutation !== undefined) {
            let data3 = data.salutation;
            if (typeof data3 !== "string") {
                const err19 = { instancePath: instancePath + "/salutation", schemaPath: "#/properties/salutation/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
            if (!(((data3 === "Herr") || (data3 === "Frau")) || (data3 === "Divers"))) {
                const err20 = { instancePath: instancePath + "/salutation", schemaPath: "#/properties/salutation/enum", keyword: "enum", params: { allowedValues: schema11.properties.salutation.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err20];
                }
                else {
                    vErrors.push(err20);
                }
                errors++;
            }
        }
        if (data.firstName !== undefined) {
            let data4 = data.firstName;
            if (typeof data4 === "string") {
                if (func3(data4) < 1) {
                    const err21 = { instancePath: instancePath + "/firstName", schemaPath: "#/properties/firstName/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            else {
                const err22 = { instancePath: instancePath + "/firstName", schemaPath: "#/properties/firstName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.lastName !== undefined) {
            let data5 = data.lastName;
            if (typeof data5 === "string") {
                if (func3(data5) < 1) {
                    const err23 = { instancePath: instancePath + "/lastName", schemaPath: "#/properties/lastName/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = { instancePath: instancePath + "/lastName", schemaPath: "#/properties/lastName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.email !== undefined) {
            let data6 = data.email;
            if (typeof data6 === "string") {
                if (!(formats0(data6))) {
                    const err25 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/format", keyword: "format", params: { format: "idn-email" }, message: "must match format \"" + "idn-email" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            else {
                const err26 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err26];
                }
                else {
                    vErrors.push(err26);
                }
                errors++;
            }
        }
        if (data.phoneCountry !== undefined) {
            let data7 = data.phoneCountry;
            if (typeof data7 === "string") {
                if (func3(data7) < 1) {
                    const err27 = { instancePath: instancePath + "/phoneCountry", schemaPath: "#/properties/phoneCountry/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
            else {
                const err28 = { instancePath: instancePath + "/phoneCountry", schemaPath: "#/properties/phoneCountry/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.phone !== undefined) {
            let data8 = data.phone;
            if (typeof data8 === "string") {
                if (func3(data8) < 1) {
                    const err29 = { instancePath: instancePath + "/phone", schemaPath: "#/properties/phone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if (!pattern0.test(data8)) {
                    const err30 = { instancePath: instancePath + "/phone", schemaPath: "#/properties/phone/pattern", keyword: "pattern", params: { pattern: "^[0-9]+$" }, message: "must match pattern \"" + "^[0-9]+$" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            else {
                const err31 = { instancePath: instancePath + "/phone", schemaPath: "#/properties/phone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
        }
        if (data.street !== undefined) {
            let data9 = data.street;
            if (typeof data9 === "string") {
                if (func3(data9) < 1) {
                    const err32 = { instancePath: instancePath + "/street", schemaPath: "#/properties/street/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            else {
                const err33 = { instancePath: instancePath + "/street", schemaPath: "#/properties/street/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
        }
        if (data.postalCode !== undefined) {
            let data10 = data.postalCode;
            if (typeof data10 === "string") {
                if (func3(data10) < 1) {
                    const err34 = { instancePath: instancePath + "/postalCode", schemaPath: "#/properties/postalCode/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
            }
            else {
                const err35 = { instancePath: instancePath + "/postalCode", schemaPath: "#/properties/postalCode/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
        }
        if (data.city !== undefined) {
            let data11 = data.city;
            if (typeof data11 === "string") {
                if (func3(data11) < 1) {
                    const err36 = { instancePath: instancePath + "/city", schemaPath: "#/properties/city/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
            }
            else {
                const err37 = { instancePath: instancePath + "/city", schemaPath: "#/properties/city/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err37];
                }
                else {
                    vErrors.push(err37);
                }
                errors++;
            }
        }
        if (data.privacyConsent !== undefined) {
            if (true !== data.privacyConsent) {
                const err38 = { instancePath: instancePath + "/privacyConsent", schemaPath: "#/properties/privacyConsent/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                if (vErrors === null) {
                    vErrors = [err38];
                }
                else {
                    vErrors.push(err38);
                }
                errors++;
            }
        }
    }
    else {
        const err39 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err39];
        }
        else {
            vErrors.push(err39);
        }
        errors++;
    }
    validate10.errors = vErrors;
    return errors === 0;
}
export const appointmentBookResponse = validate11;
const schema12 = { "$id": "#/definitions/appointmentBookResponse", "type": "object", "additionalProperties": false, "properties": { "status": { "const": "ok" }, "appointmentStart": { "type": "string", "format": "date-time" } }, "required": ["status", "appointmentStart"] };
import __req_formats2 from "../formats.js";
const formats2 = __req_formats2["date-time"];
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/appointmentBookResponse" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.status === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.appointmentStart === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "appointmentStart" }, message: "must have required property '" + "appointmentStart" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!((key0 === "status") || (key0 === "appointmentStart"))) {
                const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.status !== undefined) {
            if ("ok" !== data.status) {
                const err3 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/const", keyword: "const", params: { allowedValue: "ok" }, message: "must be equal to constant" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.appointmentStart !== undefined) {
            let data1 = data.appointmentStart;
            if (typeof data1 === "string") {
                if (!(formats2.validate(data1))) {
                    const err4 = { instancePath: instancePath + "/appointmentStart", schemaPath: "#/properties/appointmentStart/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            else {
                const err5 = { instancePath: instancePath + "/appointmentStart", schemaPath: "#/properties/appointmentStart/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
    }
    else {
        const err6 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err6];
        }
        else {
            vErrors.push(err6);
        }
        errors++;
    }
    validate11.errors = vErrors;
    return errors === 0;
}
export const appointmentSaveRequest = validate12;
const schema13 = { "$id": "#/definitions/appointmentSaveRequest", "type": "object", "additionalProperties": false, "properties": { "id": { "type": ["number", "null"] }, "therapistId": { "type": "integer" }, "customerId": { "type": "integer" }, "appointmentStart": { "type": "string", "format": "date-time" }, "appointmentEnd": { "type": "string", "format": "date-time" }, "typeId": { "type": "integer" }, "bookability": { "type": "string", "enum": ["public", "internal"] }, "sendEmails": { "type": "boolean" }, "location": { "type": ["string", "null"], "enum": ["onSite", "remote", "both", null], "nullable": true }, "notes": { "type": ["string", "null"] }, "maxParticipants": { "type": "integer", "minimum": 1, "maximum": 50 }, "series": { "type": "object", "additionalProperties": false, "properties": { "interval": { "type": "string", "enum": ["P1W", "P2W", "P3W", "P4W"] }, "count": { "type": "number", "minimum": 1, "maximum": 50 } }, "required": ["interval", "count"] }, "clientRemoveAction": { "type": "string", "enum": ["cancel", "delete"] }, "clients": { "type": "array", "maxItems": 50, "uniqueItems": true, "items": { "type": "object", "additionalProperties": false, "properties": { "id": { "type": ["integer", "null"] }, "salutation": { "type": ["string", "null"], "enum": ["Herr", "Frau", "Divers", null], "nullable": true }, "title": { "type": ["string", "null"] }, "firstName": { "type": "string" }, "lastName": { "type": "string" }, "email": { "type": "string", "format": "idn-email" }, "phoneCountry": { "type": ["string", "null"] }, "phone": { "type": ["string", "null"] }, "insuranceType": { "type": ["string", "null"], "enum": ["legally", "privately", null], "nullable": true }, "street": { "type": ["string", "null"] }, "postalCode": { "type": ["string", "null"] }, "city": { "type": ["string", "null"] } }, "required": ["firstName", "lastName", "email"] } }, "medicalFeeSchedules": { "type": "array", "maxItems": 50, "items": { "oneOf": [{ "type": "object", "additionalProperties": false, "properties": { "id": { "type": "number" }, "codeValue": { "type": "string" }, "alternativeTitle": { "type": ["string", "null"], "nullable": true }, "incrementalRate": { "type": "string" }, "coachingTitle": { "type": "null" }, "coachingAmount": { "type": "null" }, "coachingAmountTax": { "type": "null" } }, "required": ["codeValue", "incrementalRate"] }, { "type": "object", "additionalProperties": false, "properties": { "id": { "type": "number" }, "codeValue": { "type": "null" }, "alternativeTitle": { "type": "null" }, "incrementalRate": { "type": "null" }, "coachingTitle": { "type": "string" }, "coachingAmount": { "type": "string" }, "coachingAmountTax": { "type": "string", "enum": ["notax", "add"] } }, "required": ["coachingTitle", "coachingAmount", "coachingAmountTax"] }] } } }, "required": ["therapistId", "customerId", "appointmentStart", "appointmentEnd", "typeId", "bookability", "sendEmails", "location", "notes", "clients", "medicalFeeSchedules"] };
import __req_func0 from "ajv/dist/runtime/equal.js";
const func0 = __req_func0.default;
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/appointmentSaveRequest" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.therapistId === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "therapistId" }, message: "must have required property '" + "therapistId" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.customerId === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "customerId" }, message: "must have required property '" + "customerId" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.appointmentStart === undefined) {
            const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "appointmentStart" }, message: "must have required property '" + "appointmentStart" + "'" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.appointmentEnd === undefined) {
            const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "appointmentEnd" }, message: "must have required property '" + "appointmentEnd" + "'" };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (data.typeId === undefined) {
            const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "typeId" }, message: "must have required property '" + "typeId" + "'" };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
        if (data.bookability === undefined) {
            const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "bookability" }, message: "must have required property '" + "bookability" + "'" };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (data.sendEmails === undefined) {
            const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "sendEmails" }, message: "must have required property '" + "sendEmails" + "'" };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
        if (data.location === undefined) {
            const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "location" }, message: "must have required property '" + "location" + "'" };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
        }
        if (data.notes === undefined) {
            const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "notes" }, message: "must have required property '" + "notes" + "'" };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
        if (data.clients === undefined) {
            const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "clients" }, message: "must have required property '" + "clients" + "'" };
            if (vErrors === null) {
                vErrors = [err9];
            }
            else {
                vErrors.push(err9);
            }
            errors++;
        }
        if (data.medicalFeeSchedules === undefined) {
            const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "medicalFeeSchedules" }, message: "must have required property '" + "medicalFeeSchedules" + "'" };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(func2.call(schema13.properties, key0))) {
                const err11 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.id !== undefined) {
            let data0 = data.id;
            if ((!((typeof data0 == "number") && (isFinite(data0)))) && (data0 !== null)) {
                const err12 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: schema13.properties.id.type }, message: "must be number,null" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.therapistId !== undefined) {
            let data1 = data.therapistId;
            if (!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))) {
                const err13 = { instancePath: instancePath + "/therapistId", schemaPath: "#/properties/therapistId/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
        if (data.customerId !== undefined) {
            let data2 = data.customerId;
            if (!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))) {
                const err14 = { instancePath: instancePath + "/customerId", schemaPath: "#/properties/customerId/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.appointmentStart !== undefined) {
            let data3 = data.appointmentStart;
            if (typeof data3 === "string") {
                if (!(formats2.validate(data3))) {
                    const err15 = { instancePath: instancePath + "/appointmentStart", schemaPath: "#/properties/appointmentStart/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            else {
                const err16 = { instancePath: instancePath + "/appointmentStart", schemaPath: "#/properties/appointmentStart/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.appointmentEnd !== undefined) {
            let data4 = data.appointmentEnd;
            if (typeof data4 === "string") {
                if (!(formats2.validate(data4))) {
                    const err17 = { instancePath: instancePath + "/appointmentEnd", schemaPath: "#/properties/appointmentEnd/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            else {
                const err18 = { instancePath: instancePath + "/appointmentEnd", schemaPath: "#/properties/appointmentEnd/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.typeId !== undefined) {
            let data5 = data.typeId;
            if (!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))) {
                const err19 = { instancePath: instancePath + "/typeId", schemaPath: "#/properties/typeId/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
        }
        if (data.bookability !== undefined) {
            let data6 = data.bookability;
            if (typeof data6 !== "string") {
                const err20 = { instancePath: instancePath + "/bookability", schemaPath: "#/properties/bookability/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err20];
                }
                else {
                    vErrors.push(err20);
                }
                errors++;
            }
            if (!((data6 === "public") || (data6 === "internal"))) {
                const err21 = { instancePath: instancePath + "/bookability", schemaPath: "#/properties/bookability/enum", keyword: "enum", params: { allowedValues: schema13.properties.bookability.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err21];
                }
                else {
                    vErrors.push(err21);
                }
                errors++;
            }
        }
        if (data.sendEmails !== undefined) {
            if (typeof data.sendEmails !== "boolean") {
                const err22 = { instancePath: instancePath + "/sendEmails", schemaPath: "#/properties/sendEmails/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.location !== undefined) {
            let data8 = data.location;
            if ((typeof data8 !== "string") && (data8 !== null)) {
                const err23 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/type", keyword: "type", params: { type: schema13.properties.location.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err23];
                }
                else {
                    vErrors.push(err23);
                }
                errors++;
            }
            if (!((((data8 === "onSite") || (data8 === "remote")) || (data8 === "both")) || (data8 === null))) {
                const err24 = { instancePath: instancePath + "/location", schemaPath: "#/properties/location/enum", keyword: "enum", params: { allowedValues: schema13.properties.location.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.notes !== undefined) {
            let data9 = data.notes;
            if ((typeof data9 !== "string") && (data9 !== null)) {
                const err25 = { instancePath: instancePath + "/notes", schemaPath: "#/properties/notes/type", keyword: "type", params: { type: schema13.properties.notes.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
        if (data.maxParticipants !== undefined) {
            let data10 = data.maxParticipants;
            if (!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))) {
                const err26 = { instancePath: instancePath + "/maxParticipants", schemaPath: "#/properties/maxParticipants/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err26];
                }
                else {
                    vErrors.push(err26);
                }
                errors++;
            }
            if ((typeof data10 == "number") && (isFinite(data10))) {
                if (data10 > 50 || isNaN(data10)) {
                    const err27 = { instancePath: instancePath + "/maxParticipants", schemaPath: "#/properties/maxParticipants/maximum", keyword: "maximum", params: { comparison: "<=", limit: 50 }, message: "must be <= 50" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
                if (data10 < 1 || isNaN(data10)) {
                    const err28 = { instancePath: instancePath + "/maxParticipants", schemaPath: "#/properties/maxParticipants/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
        }
        if (data.series !== undefined) {
            let data11 = data.series;
            if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
                if (data11.interval === undefined) {
                    const err29 = { instancePath: instancePath + "/series", schemaPath: "#/properties/series/required", keyword: "required", params: { missingProperty: "interval" }, message: "must have required property '" + "interval" + "'" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if (data11.count === undefined) {
                    const err30 = { instancePath: instancePath + "/series", schemaPath: "#/properties/series/required", keyword: "required", params: { missingProperty: "count" }, message: "must have required property '" + "count" + "'" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                for (const key1 in data11) {
                    if (!((key1 === "interval") || (key1 === "count"))) {
                        const err31 = { instancePath: instancePath + "/series", schemaPath: "#/properties/series/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
                if (data11.interval !== undefined) {
                    let data12 = data11.interval;
                    if (typeof data12 !== "string") {
                        const err32 = { instancePath: instancePath + "/series/interval", schemaPath: "#/properties/series/properties/interval/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                    if (!((((data12 === "P1W") || (data12 === "P2W")) || (data12 === "P3W")) || (data12 === "P4W"))) {
                        const err33 = { instancePath: instancePath + "/series/interval", schemaPath: "#/properties/series/properties/interval/enum", keyword: "enum", params: { allowedValues: schema13.properties.series.properties.interval.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                }
                if (data11.count !== undefined) {
                    let data13 = data11.count;
                    if ((typeof data13 == "number") && (isFinite(data13))) {
                        if (data13 > 50 || isNaN(data13)) {
                            const err34 = { instancePath: instancePath + "/series/count", schemaPath: "#/properties/series/properties/count/maximum", keyword: "maximum", params: { comparison: "<=", limit: 50 }, message: "must be <= 50" };
                            if (vErrors === null) {
                                vErrors = [err34];
                            }
                            else {
                                vErrors.push(err34);
                            }
                            errors++;
                        }
                        if (data13 < 1 || isNaN(data13)) {
                            const err35 = { instancePath: instancePath + "/series/count", schemaPath: "#/properties/series/properties/count/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                            if (vErrors === null) {
                                vErrors = [err35];
                            }
                            else {
                                vErrors.push(err35);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err36 = { instancePath: instancePath + "/series/count", schemaPath: "#/properties/series/properties/count/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                        if (vErrors === null) {
                            vErrors = [err36];
                        }
                        else {
                            vErrors.push(err36);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err37 = { instancePath: instancePath + "/series", schemaPath: "#/properties/series/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                    vErrors = [err37];
                }
                else {
                    vErrors.push(err37);
                }
                errors++;
            }
        }
        if (data.clientRemoveAction !== undefined) {
            let data14 = data.clientRemoveAction;
            if (typeof data14 !== "string") {
                const err38 = { instancePath: instancePath + "/clientRemoveAction", schemaPath: "#/properties/clientRemoveAction/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err38];
                }
                else {
                    vErrors.push(err38);
                }
                errors++;
            }
            if (!((data14 === "cancel") || (data14 === "delete"))) {
                const err39 = { instancePath: instancePath + "/clientRemoveAction", schemaPath: "#/properties/clientRemoveAction/enum", keyword: "enum", params: { allowedValues: schema13.properties.clientRemoveAction.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err39];
                }
                else {
                    vErrors.push(err39);
                }
                errors++;
            }
        }
        if (data.clients !== undefined) {
            let data15 = data.clients;
            if (Array.isArray(data15)) {
                if (data15.length > 50) {
                    const err40 = { instancePath: instancePath + "/clients", schemaPath: "#/properties/clients/maxItems", keyword: "maxItems", params: { limit: 50 }, message: "must NOT have more than 50 items" };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
                const len0 = data15.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data16 = data15[i0];
                    if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                        if (data16.firstName === undefined) {
                            const err41 = { instancePath: instancePath + "/clients/" + i0, schemaPath: "#/properties/clients/items/required", keyword: "required", params: { missingProperty: "firstName" }, message: "must have required property '" + "firstName" + "'" };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                        if (data16.lastName === undefined) {
                            const err42 = { instancePath: instancePath + "/clients/" + i0, schemaPath: "#/properties/clients/items/required", keyword: "required", params: { missingProperty: "lastName" }, message: "must have required property '" + "lastName" + "'" };
                            if (vErrors === null) {
                                vErrors = [err42];
                            }
                            else {
                                vErrors.push(err42);
                            }
                            errors++;
                        }
                        if (data16.email === undefined) {
                            const err43 = { instancePath: instancePath + "/clients/" + i0, schemaPath: "#/properties/clients/items/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property '" + "email" + "'" };
                            if (vErrors === null) {
                                vErrors = [err43];
                            }
                            else {
                                vErrors.push(err43);
                            }
                            errors++;
                        }
                        for (const key2 in data16) {
                            if (!(func2.call(schema13.properties.clients.items.properties, key2))) {
                                const err44 = { instancePath: instancePath + "/clients/" + i0, schemaPath: "#/properties/clients/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                    vErrors = [err44];
                                }
                                else {
                                    vErrors.push(err44);
                                }
                                errors++;
                            }
                        }
                        if (data16.id !== undefined) {
                            let data17 = data16.id;
                            if ((!(((typeof data17 == "number") && (!(data17 % 1) && !isNaN(data17))) && (isFinite(data17)))) && (data17 !== null)) {
                                const err45 = { instancePath: instancePath + "/clients/" + i0 + "/id", schemaPath: "#/properties/clients/items/properties/id/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.id.type }, message: "must be integer,null" };
                                if (vErrors === null) {
                                    vErrors = [err45];
                                }
                                else {
                                    vErrors.push(err45);
                                }
                                errors++;
                            }
                        }
                        if (data16.salutation !== undefined) {
                            let data18 = data16.salutation;
                            if ((typeof data18 !== "string") && (data18 !== null)) {
                                const err46 = { instancePath: instancePath + "/clients/" + i0 + "/salutation", schemaPath: "#/properties/clients/items/properties/salutation/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.salutation.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                            if (!((((data18 === "Herr") || (data18 === "Frau")) || (data18 === "Divers")) || (data18 === null))) {
                                const err47 = { instancePath: instancePath + "/clients/" + i0 + "/salutation", schemaPath: "#/properties/clients/items/properties/salutation/enum", keyword: "enum", params: { allowedValues: schema13.properties.clients.items.properties.salutation.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err47];
                                }
                                else {
                                    vErrors.push(err47);
                                }
                                errors++;
                            }
                        }
                        if (data16.title !== undefined) {
                            let data19 = data16.title;
                            if ((typeof data19 !== "string") && (data19 !== null)) {
                                const err48 = { instancePath: instancePath + "/clients/" + i0 + "/title", schemaPath: "#/properties/clients/items/properties/title/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.title.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                        }
                        if (data16.firstName !== undefined) {
                            if (typeof data16.firstName !== "string") {
                                const err49 = { instancePath: instancePath + "/clients/" + i0 + "/firstName", schemaPath: "#/properties/clients/items/properties/firstName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err49];
                                }
                                else {
                                    vErrors.push(err49);
                                }
                                errors++;
                            }
                        }
                        if (data16.lastName !== undefined) {
                            if (typeof data16.lastName !== "string") {
                                const err50 = { instancePath: instancePath + "/clients/" + i0 + "/lastName", schemaPath: "#/properties/clients/items/properties/lastName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err50];
                                }
                                else {
                                    vErrors.push(err50);
                                }
                                errors++;
                            }
                        }
                        if (data16.email !== undefined) {
                            let data22 = data16.email;
                            if (typeof data22 === "string") {
                                if (!(formats0(data22))) {
                                    const err51 = { instancePath: instancePath + "/clients/" + i0 + "/email", schemaPath: "#/properties/clients/items/properties/email/format", keyword: "format", params: { format: "idn-email" }, message: "must match format \"" + "idn-email" + "\"" };
                                    if (vErrors === null) {
                                        vErrors = [err51];
                                    }
                                    else {
                                        vErrors.push(err51);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err52 = { instancePath: instancePath + "/clients/" + i0 + "/email", schemaPath: "#/properties/clients/items/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err52];
                                }
                                else {
                                    vErrors.push(err52);
                                }
                                errors++;
                            }
                        }
                        if (data16.phoneCountry !== undefined) {
                            let data23 = data16.phoneCountry;
                            if ((typeof data23 !== "string") && (data23 !== null)) {
                                const err53 = { instancePath: instancePath + "/clients/" + i0 + "/phoneCountry", schemaPath: "#/properties/clients/items/properties/phoneCountry/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.phoneCountry.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err53];
                                }
                                else {
                                    vErrors.push(err53);
                                }
                                errors++;
                            }
                        }
                        if (data16.phone !== undefined) {
                            let data24 = data16.phone;
                            if ((typeof data24 !== "string") && (data24 !== null)) {
                                const err54 = { instancePath: instancePath + "/clients/" + i0 + "/phone", schemaPath: "#/properties/clients/items/properties/phone/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.phone.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err54];
                                }
                                else {
                                    vErrors.push(err54);
                                }
                                errors++;
                            }
                        }
                        if (data16.insuranceType !== undefined) {
                            let data25 = data16.insuranceType;
                            if ((typeof data25 !== "string") && (data25 !== null)) {
                                const err55 = { instancePath: instancePath + "/clients/" + i0 + "/insuranceType", schemaPath: "#/properties/clients/items/properties/insuranceType/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.insuranceType.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err55];
                                }
                                else {
                                    vErrors.push(err55);
                                }
                                errors++;
                            }
                            if (!(((data25 === "legally") || (data25 === "privately")) || (data25 === null))) {
                                const err56 = { instancePath: instancePath + "/clients/" + i0 + "/insuranceType", schemaPath: "#/properties/clients/items/properties/insuranceType/enum", keyword: "enum", params: { allowedValues: schema13.properties.clients.items.properties.insuranceType.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err56];
                                }
                                else {
                                    vErrors.push(err56);
                                }
                                errors++;
                            }
                        }
                        if (data16.street !== undefined) {
                            let data26 = data16.street;
                            if ((typeof data26 !== "string") && (data26 !== null)) {
                                const err57 = { instancePath: instancePath + "/clients/" + i0 + "/street", schemaPath: "#/properties/clients/items/properties/street/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.street.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err57];
                                }
                                else {
                                    vErrors.push(err57);
                                }
                                errors++;
                            }
                        }
                        if (data16.postalCode !== undefined) {
                            let data27 = data16.postalCode;
                            if ((typeof data27 !== "string") && (data27 !== null)) {
                                const err58 = { instancePath: instancePath + "/clients/" + i0 + "/postalCode", schemaPath: "#/properties/clients/items/properties/postalCode/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.postalCode.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err58];
                                }
                                else {
                                    vErrors.push(err58);
                                }
                                errors++;
                            }
                        }
                        if (data16.city !== undefined) {
                            let data28 = data16.city;
                            if ((typeof data28 !== "string") && (data28 !== null)) {
                                const err59 = { instancePath: instancePath + "/clients/" + i0 + "/city", schemaPath: "#/properties/clients/items/properties/city/type", keyword: "type", params: { type: schema13.properties.clients.items.properties.city.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err59];
                                }
                                else {
                                    vErrors.push(err59);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err60 = { instancePath: instancePath + "/clients/" + i0, schemaPath: "#/properties/clients/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                }
                let i1 = data15.length;
                let j0;
                if (i1 > 1) {
                    outer0: for (; i1--;) {
                        for (j0 = i1; j0--;) {
                            if (func0(data15[i1], data15[j0])) {
                                const err61 = { instancePath: instancePath + "/clients", schemaPath: "#/properties/clients/uniqueItems", keyword: "uniqueItems", params: { i: i1, j: j0 }, message: "must NOT have duplicate items (items ## " + j0 + " and " + i1 + " are identical)" };
                                if (vErrors === null) {
                                    vErrors = [err61];
                                }
                                else {
                                    vErrors.push(err61);
                                }
                                errors++;
                                break outer0;
                            }
                        }
                    }
                }
            }
            else {
                const err62 = { instancePath: instancePath + "/clients", schemaPath: "#/properties/clients/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                    vErrors = [err62];
                }
                else {
                    vErrors.push(err62);
                }
                errors++;
            }
        }
        if (data.medicalFeeSchedules !== undefined) {
            let data29 = data.medicalFeeSchedules;
            if (Array.isArray(data29)) {
                if (data29.length > 50) {
                    const err63 = { instancePath: instancePath + "/medicalFeeSchedules", schemaPath: "#/properties/medicalFeeSchedules/maxItems", keyword: "maxItems", params: { limit: 50 }, message: "must NOT have more than 50 items" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
                const len1 = data29.length;
                for (let i2 = 0; i2 < len1; i2++) {
                    let data30 = data29[i2];
                    const _errs68 = errors;
                    let valid8 = false;
                    let passing0 = null;
                    const _errs69 = errors;
                    if (data30 && typeof data30 == "object" && !Array.isArray(data30)) {
                        if (data30.codeValue === undefined) {
                            const err64 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/required", keyword: "required", params: { missingProperty: "codeValue" }, message: "must have required property '" + "codeValue" + "'" };
                            if (vErrors === null) {
                                vErrors = [err64];
                            }
                            else {
                                vErrors.push(err64);
                            }
                            errors++;
                        }
                        if (data30.incrementalRate === undefined) {
                            const err65 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/required", keyword: "required", params: { missingProperty: "incrementalRate" }, message: "must have required property '" + "incrementalRate" + "'" };
                            if (vErrors === null) {
                                vErrors = [err65];
                            }
                            else {
                                vErrors.push(err65);
                            }
                            errors++;
                        }
                        for (const key3 in data30) {
                            if (!(((((((key3 === "id") || (key3 === "codeValue")) || (key3 === "alternativeTitle")) || (key3 === "incrementalRate")) || (key3 === "coachingTitle")) || (key3 === "coachingAmount")) || (key3 === "coachingAmountTax"))) {
                                const err66 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                    vErrors = [err66];
                                }
                                else {
                                    vErrors.push(err66);
                                }
                                errors++;
                            }
                        }
                        if (data30.id !== undefined) {
                            let data31 = data30.id;
                            if (!((typeof data31 == "number") && (isFinite(data31)))) {
                                const err67 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/id", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/id/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                if (vErrors === null) {
                                    vErrors = [err67];
                                }
                                else {
                                    vErrors.push(err67);
                                }
                                errors++;
                            }
                        }
                        if (data30.codeValue !== undefined) {
                            if (typeof data30.codeValue !== "string") {
                                const err68 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/codeValue", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/codeValue/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err68];
                                }
                                else {
                                    vErrors.push(err68);
                                }
                                errors++;
                            }
                        }
                        if (data30.alternativeTitle !== undefined) {
                            let data33 = data30.alternativeTitle;
                            if ((typeof data33 !== "string") && (data33 !== null)) {
                                const err69 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/alternativeTitle", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/alternativeTitle/type", keyword: "type", params: { type: schema13.properties.medicalFeeSchedules.items.oneOf[0].properties.alternativeTitle.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err69];
                                }
                                else {
                                    vErrors.push(err69);
                                }
                                errors++;
                            }
                        }
                        if (data30.incrementalRate !== undefined) {
                            if (typeof data30.incrementalRate !== "string") {
                                const err70 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/incrementalRate", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/incrementalRate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err70];
                                }
                                else {
                                    vErrors.push(err70);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingTitle !== undefined) {
                            if (data30.coachingTitle !== null) {
                                const err71 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingTitle", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/coachingTitle/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err71];
                                }
                                else {
                                    vErrors.push(err71);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingAmount !== undefined) {
                            if (data30.coachingAmount !== null) {
                                const err72 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingAmount", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/coachingAmount/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err72];
                                }
                                else {
                                    vErrors.push(err72);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingAmountTax !== undefined) {
                            if (data30.coachingAmountTax !== null) {
                                const err73 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingAmountTax", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/properties/coachingAmountTax/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err73];
                                }
                                else {
                                    vErrors.push(err73);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err74 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                            vErrors = [err74];
                        }
                        else {
                            vErrors.push(err74);
                        }
                        errors++;
                    }
                    var _valid0 = _errs69 === errors;
                    if (_valid0) {
                        valid8 = true;
                        passing0 = 0;
                    }
                    const _errs87 = errors;
                    if (data30 && typeof data30 == "object" && !Array.isArray(data30)) {
                        if (data30.coachingTitle === undefined) {
                            const err75 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/required", keyword: "required", params: { missingProperty: "coachingTitle" }, message: "must have required property '" + "coachingTitle" + "'" };
                            if (vErrors === null) {
                                vErrors = [err75];
                            }
                            else {
                                vErrors.push(err75);
                            }
                            errors++;
                        }
                        if (data30.coachingAmount === undefined) {
                            const err76 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/required", keyword: "required", params: { missingProperty: "coachingAmount" }, message: "must have required property '" + "coachingAmount" + "'" };
                            if (vErrors === null) {
                                vErrors = [err76];
                            }
                            else {
                                vErrors.push(err76);
                            }
                            errors++;
                        }
                        if (data30.coachingAmountTax === undefined) {
                            const err77 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/required", keyword: "required", params: { missingProperty: "coachingAmountTax" }, message: "must have required property '" + "coachingAmountTax" + "'" };
                            if (vErrors === null) {
                                vErrors = [err77];
                            }
                            else {
                                vErrors.push(err77);
                            }
                            errors++;
                        }
                        for (const key4 in data30) {
                            if (!(((((((key4 === "id") || (key4 === "codeValue")) || (key4 === "alternativeTitle")) || (key4 === "incrementalRate")) || (key4 === "coachingTitle")) || (key4 === "coachingAmount")) || (key4 === "coachingAmountTax"))) {
                                const err78 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                    vErrors = [err78];
                                }
                                else {
                                    vErrors.push(err78);
                                }
                                errors++;
                            }
                        }
                        if (data30.id !== undefined) {
                            let data38 = data30.id;
                            if (!((typeof data38 == "number") && (isFinite(data38)))) {
                                const err79 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/id", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/id/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                                if (vErrors === null) {
                                    vErrors = [err79];
                                }
                                else {
                                    vErrors.push(err79);
                                }
                                errors++;
                            }
                        }
                        if (data30.codeValue !== undefined) {
                            if (data30.codeValue !== null) {
                                const err80 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/codeValue", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/codeValue/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err80];
                                }
                                else {
                                    vErrors.push(err80);
                                }
                                errors++;
                            }
                        }
                        if (data30.alternativeTitle !== undefined) {
                            if (data30.alternativeTitle !== null) {
                                const err81 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/alternativeTitle", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/alternativeTitle/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err81];
                                }
                                else {
                                    vErrors.push(err81);
                                }
                                errors++;
                            }
                        }
                        if (data30.incrementalRate !== undefined) {
                            if (data30.incrementalRate !== null) {
                                const err82 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/incrementalRate", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/incrementalRate/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                                if (vErrors === null) {
                                    vErrors = [err82];
                                }
                                else {
                                    vErrors.push(err82);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingTitle !== undefined) {
                            if (typeof data30.coachingTitle !== "string") {
                                const err83 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingTitle", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/coachingTitle/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err83];
                                }
                                else {
                                    vErrors.push(err83);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingAmount !== undefined) {
                            if (typeof data30.coachingAmount !== "string") {
                                const err84 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingAmount", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/coachingAmount/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err84];
                                }
                                else {
                                    vErrors.push(err84);
                                }
                                errors++;
                            }
                        }
                        if (data30.coachingAmountTax !== undefined) {
                            let data44 = data30.coachingAmountTax;
                            if (typeof data44 !== "string") {
                                const err85 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingAmountTax", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/coachingAmountTax/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err85];
                                }
                                else {
                                    vErrors.push(err85);
                                }
                                errors++;
                            }
                            if (!((data44 === "notax") || (data44 === "add"))) {
                                const err86 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2 + "/coachingAmountTax", schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/properties/coachingAmountTax/enum", keyword: "enum", params: { allowedValues: schema13.properties.medicalFeeSchedules.items.oneOf[1].properties.coachingAmountTax.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err86];
                                }
                                else {
                                    vErrors.push(err86);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err87 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf/1/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                            vErrors = [err87];
                        }
                        else {
                            vErrors.push(err87);
                        }
                        errors++;
                    }
                    var _valid0 = _errs87 === errors;
                    if (_valid0 && valid8) {
                        valid8 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid8 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid8) {
                        const err88 = { instancePath: instancePath + "/medicalFeeSchedules/" + i2, schemaPath: "#/properties/medicalFeeSchedules/items/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                        if (vErrors === null) {
                            vErrors = [err88];
                        }
                        else {
                            vErrors.push(err88);
                        }
                        errors++;
                    }
                    else {
                        errors = _errs68;
                        if (vErrors !== null) {
                            if (_errs68) {
                                vErrors.length = _errs68;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
            else {
                const err89 = { instancePath: instancePath + "/medicalFeeSchedules", schemaPath: "#/properties/medicalFeeSchedules/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                    vErrors = [err89];
                }
                else {
                    vErrors.push(err89);
                }
                errors++;
            }
        }
    }
    else {
        const err90 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err90];
        }
        else {
            vErrors.push(err90);
        }
        errors++;
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const appointmentSaveResponse = validate13;
const schema14 = { "$id": "#/definitions/appointmentSaveResponse", "type": "object", "additionalProperties": false, "properties": { "id": { "type": "integer" }, "seriesId": { "type": ["string", "null"] } }, "required": ["id"] };
function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/appointmentSaveResponse" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.id === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!((key0 === "id") || (key0 === "seriesId"))) {
                const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.id !== undefined) {
            let data0 = data.id;
            if (!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))) {
                const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.seriesId !== undefined) {
            let data1 = data.seriesId;
            if ((typeof data1 !== "string") && (data1 !== null)) {
                const err3 = { instancePath: instancePath + "/seriesId", schemaPath: "#/properties/seriesId/type", keyword: "type", params: { type: schema14.properties.seriesId.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
    }
    else {
        const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err4];
        }
        else {
            vErrors.push(err4);
        }
        errors++;
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const searchBookableAppointmentsRequest = validate14;
const schema15 = { "$id": "#/definitions/searchBookableAppointmentsRequest", "type": "object", "additionalProperties": false, "properties": { "therapistId": { "type": "integer" }, "startDate": { "type": "string", "format": "date-time" }, "endDate": { "type": ["string", "null"], "format": "date-time", "nullable": true }, "insuranceType": { "type": "string", "enum": ["legally", "privately"] }, "meetingTypeId": { "type": "integer" } }, "required": ["therapistId", "startDate"] };
function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/searchBookableAppointmentsRequest" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.therapistId === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "therapistId" }, message: "must have required property '" + "therapistId" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.startDate === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "startDate" }, message: "must have required property '" + "startDate" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(((((key0 === "therapistId") || (key0 === "startDate")) || (key0 === "endDate")) || (key0 === "insuranceType")) || (key0 === "meetingTypeId"))) {
                const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.therapistId !== undefined) {
            let data0 = data.therapistId;
            if (!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))) {
                const err3 = { instancePath: instancePath + "/therapistId", schemaPath: "#/properties/therapistId/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.startDate !== undefined) {
            let data1 = data.startDate;
            if (typeof data1 === "string") {
                if (!(formats2.validate(data1))) {
                    const err4 = { instancePath: instancePath + "/startDate", schemaPath: "#/properties/startDate/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            else {
                const err5 = { instancePath: instancePath + "/startDate", schemaPath: "#/properties/startDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
        if (data.endDate !== undefined) {
            let data2 = data.endDate;
            if ((typeof data2 !== "string") && (data2 !== null)) {
                const err6 = { instancePath: instancePath + "/endDate", schemaPath: "#/properties/endDate/type", keyword: "type", params: { type: schema15.properties.endDate.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (typeof data2 === "string") {
                if (!(formats2.validate(data2))) {
                    const err7 = { instancePath: instancePath + "/endDate", schemaPath: "#/properties/endDate/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
        }
        if (data.insuranceType !== undefined) {
            let data3 = data.insuranceType;
            if (typeof data3 !== "string") {
                const err8 = { instancePath: instancePath + "/insuranceType", schemaPath: "#/properties/insuranceType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (!((data3 === "legally") || (data3 === "privately"))) {
                const err9 = { instancePath: instancePath + "/insuranceType", schemaPath: "#/properties/insuranceType/enum", keyword: "enum", params: { allowedValues: schema15.properties.insuranceType.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
        }
        if (data.meetingTypeId !== undefined) {
            let data4 = data.meetingTypeId;
            if (!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))) {
                const err10 = { instancePath: instancePath + "/meetingTypeId", schemaPath: "#/properties/meetingTypeId/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
    }
    else {
        const err11 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err11];
        }
        else {
            vErrors.push(err11);
        }
        errors++;
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const searchBookableAppointmentsResponse = validate15;
const schema16 = { "$id": "#/definitions/searchBookableAppointmentsResponse", "type": "object", "additionalProperties": false, "properties": { "status": { "const": "ok" }, "appointments": { "type": "array", "items": { "type": "object", "additionalProperties": false, "properties": { "id": { "type": "integer" }, "appointmentStart": { "type": "string", "format": "date-time" } }, "required": ["id", "appointmentStart"] } }, "types": { "type": "array", "items": { "type": "object", "additionalProperties": false, "properties": { "id": { "type": "integer" }, "name": { "type": "string" }, "insuranceType": { "type": ["string", "null"], "enum": ["legally", "privately", null], "nullable": true }, "location": { "type": "string", "enum": ["onSite", "remote", "both"] }, "duration": { "type": "integer" } }, "required": ["id", "name", "insuranceType", "location", "duration"] } }, "typesFiltered": { "type": "array", "items": { "type": "integer" } }, "prevCursor": { "type": ["string", "null"], "nullable": true, "format": "date-time" }, "nextCursor": { "type": ["string", "null"], "nullable": true, "format": "date-time" } }, "required": ["status", "appointments", "types", "typesFiltered", "prevCursor", "nextCursor"] };
function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="#/definitions/searchBookableAppointmentsResponse" */ ;
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.status === undefined) {
            const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.appointments === undefined) {
            const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "appointments" }, message: "must have required property '" + "appointments" + "'" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.types === undefined) {
            const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "types" }, message: "must have required property '" + "types" + "'" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.typesFiltered === undefined) {
            const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "typesFiltered" }, message: "must have required property '" + "typesFiltered" + "'" };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (data.prevCursor === undefined) {
            const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prevCursor" }, message: "must have required property '" + "prevCursor" + "'" };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
        if (data.nextCursor === undefined) {
            const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "nextCursor" }, message: "must have required property '" + "nextCursor" + "'" };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!((((((key0 === "status") || (key0 === "appointments")) || (key0 === "types")) || (key0 === "typesFiltered")) || (key0 === "prevCursor")) || (key0 === "nextCursor"))) {
                const err6 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
        }
        if (data.status !== undefined) {
            if ("ok" !== data.status) {
                const err7 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/const", keyword: "const", params: { allowedValue: "ok" }, message: "must be equal to constant" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
        }
        if (data.appointments !== undefined) {
            let data1 = data.appointments;
            if (Array.isArray(data1)) {
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                        if (data2.id === undefined) {
                            const err8 = { instancePath: instancePath + "/appointments/" + i0, schemaPath: "#/properties/appointments/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                        if (data2.appointmentStart === undefined) {
                            const err9 = { instancePath: instancePath + "/appointments/" + i0, schemaPath: "#/properties/appointments/items/required", keyword: "required", params: { missingProperty: "appointmentStart" }, message: "must have required property '" + "appointmentStart" + "'" };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        for (const key1 in data2) {
                            if (!((key1 === "id") || (key1 === "appointmentStart"))) {
                                const err10 = { instancePath: instancePath + "/appointments/" + i0, schemaPath: "#/properties/appointments/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                        }
                        if (data2.id !== undefined) {
                            let data3 = data2.id;
                            if (!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))) {
                                const err11 = { instancePath: instancePath + "/appointments/" + i0 + "/id", schemaPath: "#/properties/appointments/items/properties/id/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                        }
                        if (data2.appointmentStart !== undefined) {
                            let data4 = data2.appointmentStart;
                            if (typeof data4 === "string") {
                                if (!(formats2.validate(data4))) {
                                    const err12 = { instancePath: instancePath + "/appointments/" + i0 + "/appointmentStart", schemaPath: "#/properties/appointments/items/properties/appointmentStart/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                                    if (vErrors === null) {
                                        vErrors = [err12];
                                    }
                                    else {
                                        vErrors.push(err12);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err13 = { instancePath: instancePath + "/appointments/" + i0 + "/appointmentStart", schemaPath: "#/properties/appointments/items/properties/appointmentStart/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err14 = { instancePath: instancePath + "/appointments/" + i0, schemaPath: "#/properties/appointments/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err15 = { instancePath: instancePath + "/appointments", schemaPath: "#/properties/appointments/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.types !== undefined) {
            let data5 = data.types;
            if (Array.isArray(data5)) {
                const len1 = data5.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data6 = data5[i1];
                    if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                        if (data6.id === undefined) {
                            const err16 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                        if (data6.name === undefined) {
                            const err17 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'" };
                            if (vErrors === null) {
                                vErrors = [err17];
                            }
                            else {
                                vErrors.push(err17);
                            }
                            errors++;
                        }
                        if (data6.insuranceType === undefined) {
                            const err18 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/required", keyword: "required", params: { missingProperty: "insuranceType" }, message: "must have required property '" + "insuranceType" + "'" };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                        if (data6.location === undefined) {
                            const err19 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/required", keyword: "required", params: { missingProperty: "location" }, message: "must have required property '" + "location" + "'" };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6.duration === undefined) {
                            const err20 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/required", keyword: "required", params: { missingProperty: "duration" }, message: "must have required property '" + "duration" + "'" };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                        for (const key2 in data6) {
                            if (!(((((key2 === "id") || (key2 === "name")) || (key2 === "insuranceType")) || (key2 === "location")) || (key2 === "duration"))) {
                                const err21 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                        }
                        if (data6.id !== undefined) {
                            let data7 = data6.id;
                            if (!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))) {
                                const err22 = { instancePath: instancePath + "/types/" + i1 + "/id", schemaPath: "#/properties/types/items/properties/id/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                        }
                        if (data6.name !== undefined) {
                            if (typeof data6.name !== "string") {
                                const err23 = { instancePath: instancePath + "/types/" + i1 + "/name", schemaPath: "#/properties/types/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                            }
                        }
                        if (data6.insuranceType !== undefined) {
                            let data9 = data6.insuranceType;
                            if ((typeof data9 !== "string") && (data9 !== null)) {
                                const err24 = { instancePath: instancePath + "/types/" + i1 + "/insuranceType", schemaPath: "#/properties/types/items/properties/insuranceType/type", keyword: "type", params: { type: schema16.properties.types.items.properties.insuranceType.type }, message: "must be string,null" };
                                if (vErrors === null) {
                                    vErrors = [err24];
                                }
                                else {
                                    vErrors.push(err24);
                                }
                                errors++;
                            }
                            if (!(((data9 === "legally") || (data9 === "privately")) || (data9 === null))) {
                                const err25 = { instancePath: instancePath + "/types/" + i1 + "/insuranceType", schemaPath: "#/properties/types/items/properties/insuranceType/enum", keyword: "enum", params: { allowedValues: schema16.properties.types.items.properties.insuranceType.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err25];
                                }
                                else {
                                    vErrors.push(err25);
                                }
                                errors++;
                            }
                        }
                        if (data6.location !== undefined) {
                            let data10 = data6.location;
                            if (typeof data10 !== "string") {
                                const err26 = { instancePath: instancePath + "/types/" + i1 + "/location", schemaPath: "#/properties/types/items/properties/location/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                    vErrors = [err26];
                                }
                                else {
                                    vErrors.push(err26);
                                }
                                errors++;
                            }
                            if (!(((data10 === "onSite") || (data10 === "remote")) || (data10 === "both"))) {
                                const err27 = { instancePath: instancePath + "/types/" + i1 + "/location", schemaPath: "#/properties/types/items/properties/location/enum", keyword: "enum", params: { allowedValues: schema16.properties.types.items.properties.location.enum }, message: "must be equal to one of the allowed values" };
                                if (vErrors === null) {
                                    vErrors = [err27];
                                }
                                else {
                                    vErrors.push(err27);
                                }
                                errors++;
                            }
                        }
                        if (data6.duration !== undefined) {
                            let data11 = data6.duration;
                            if (!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))) {
                                const err28 = { instancePath: instancePath + "/types/" + i1 + "/duration", schemaPath: "#/properties/types/items/properties/duration/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                    vErrors = [err28];
                                }
                                else {
                                    vErrors.push(err28);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err29 = { instancePath: instancePath + "/types/" + i1, schemaPath: "#/properties/types/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                            vErrors = [err29];
                        }
                        else {
                            vErrors.push(err29);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err30 = { instancePath: instancePath + "/types", schemaPath: "#/properties/types/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                    vErrors = [err30];
                }
                else {
                    vErrors.push(err30);
                }
                errors++;
            }
        }
        if (data.typesFiltered !== undefined) {
            let data12 = data.typesFiltered;
            if (Array.isArray(data12)) {
                const len2 = data12.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data13 = data12[i2];
                    if (!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))) {
                        const err31 = { instancePath: instancePath + "/typesFiltered/" + i2, schemaPath: "#/properties/typesFiltered/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err32 = { instancePath: instancePath + "/typesFiltered", schemaPath: "#/properties/typesFiltered/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                    vErrors = [err32];
                }
                else {
                    vErrors.push(err32);
                }
                errors++;
            }
        }
        if (data.prevCursor !== undefined) {
            let data14 = data.prevCursor;
            if ((typeof data14 !== "string") && (data14 !== null)) {
                const err33 = { instancePath: instancePath + "/prevCursor", schemaPath: "#/properties/prevCursor/type", keyword: "type", params: { type: schema16.properties.prevCursor.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
            if (typeof data14 === "string") {
                if (!(formats2.validate(data14))) {
                    const err34 = { instancePath: instancePath + "/prevCursor", schemaPath: "#/properties/prevCursor/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
            }
        }
        if (data.nextCursor !== undefined) {
            let data15 = data.nextCursor;
            if ((typeof data15 !== "string") && (data15 !== null)) {
                const err35 = { instancePath: instancePath + "/nextCursor", schemaPath: "#/properties/nextCursor/type", keyword: "type", params: { type: schema16.properties.nextCursor.type }, message: "must be string,null" };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
            if (typeof data15 === "string") {
                if (!(formats2.validate(data15))) {
                    const err36 = { instancePath: instancePath + "/nextCursor", schemaPath: "#/properties/nextCursor/format", keyword: "format", params: { format: "date-time" }, message: "must match format \"" + "date-time" + "\"" };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
            }
        }
    }
    else {
        const err37 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
            vErrors = [err37];
        }
        else {
            vErrors.push(err37);
        }
        errors++;
    }
    validate15.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=AppointmentApi.generated.mjs.map